<script>
    import * as types from '../../store/types.js';

    export default {
        name: 'dm-product-list-action',
        functional: true,
        props: {
            href: {
                type: String,
                required: true
            },
            crawlable: {
                type: Boolean,
                default: true
            }
        },
        render(h, { data, props, children, parent }) {
            const tag = props.crawlable ? 'a' : 'span';
            const href = props.crawlable ? props.href : false;
            const classNames = (data && data.class) ? data.class : [];

            return h(tag, {
                attrs: { href, ...data.attrs },
                class: ['dml-link', ...classNames],
                on: {
                    'click': (e) => {
                        if (props.href !== '/' && !props.href.startsWith('/lp')) {
                            parent.$store.dispatch(types.FETCH_CURRENT_MODEL, props.href)
                            e.preventDefault();
                            setTimeout(() => {
                                window.scrollTo(0, 0);
                            }, 0);
                        }
                    }
                }
            }, children);
        }
    };
</script>
